import React, { memo } from 'react'
import { capitalize } from 'lodash'
import { TableRow, TableCell, ITableRowProps } from 'transfix-ui/components/Table'
import { CopyIcon, DeleteIcon } from 'transfix-icons'
import { Button, IconButton } from 'transfix-ui'
import { ParserVersion } from '../../types'

interface IParserVersionsTableRowProps extends Omit<ITableRowProps, 'children'> {
  onParserVersionSelect: (parserVersion: ParserVersion) => void
  onParserVersionDelete: (parserVersion: ParserVersion) => void
  onParserVersionCopy: (parserVersion: ParserVersion) => void
  parserVersion: ParserVersion
  name: string
  isLive: string
  wasEverLive: string
}

const getParserField = (field?: string) => {
  if (field !== undefined) {
    return capitalize(field).substring(0, 10)
  }
  return 'None'
}

export const ParserVersionsTableRow = memo<IParserVersionsTableRowProps>(
  ({
    isLive,
    name,
    onParserVersionCopy,
    onParserVersionDelete,
    onParserVersionSelect,
    parserVersion,
    wasEverLive,
    ...props
  }) => {
    const clickHandler = () => {
      onParserVersionSelect(parserVersion)
    }

    const deleteHandler = () => {
      onParserVersionDelete(parserVersion)
    }

    const copyHandler = () => {
      onParserVersionCopy(parserVersion)
    }

    return (
      <TableRow dataTest='ParserVersionsTableRow' {...props}>
        <TableCell>{name}</TableCell>
        <TableCell>{isLive}</TableCell>
        <TableCell>{wasEverLive}</TableCell>
        <TableCell>{getParserField(parserVersion.parser_library)}</TableCell>
        <TableCell>{getParserField(parserVersion.stupidedi_config)}</TableCell>
        <TableCell>{getParserField(parserVersion.edi_mapper_tfx12_definition_id)}</TableCell>
        <TableCell>{capitalize(parserVersion.element_conversion.substring(0, 10))}</TableCell>
        <TableCell>{capitalize(parserVersion.document_conversion.substring(0, 10))}</TableCell>
        <TableCell>
          <Button onClick={clickHandler}>Select</Button>
          <IconButton
            Icon={CopyIcon}
            color='tertiary'
            size='small'
            onClick={copyHandler}
            label='Copy Version'
          />
          <IconButton
            Icon={DeleteIcon}
            color='tertiary'
            size='small'
            onClick={deleteHandler}
            label='Delete Version'
          />
        </TableCell>
      </TableRow>
    )
  }
)
